var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-box",class:{'stepped': !!_vm.step}},[(_vm.step)?_c('div',{staticClass:"step-number mb-10"},[_c('h2',[_vm._v("Step "+_vm._s(_vm.step))])]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }